export default "__VITE_ASSET__1312fc9f__"